<template>
  <div>
        <!-- User Count Display -->
    <div class="showing-div" style="margin-left: 40px; color:#006C6B !important;font-weight: bold; margin-bottom: 20px;">
      <p>貴社に興味を持ちキャリア登録した方の中で、あなたに確認依頼されている登録者を表示しています。お早めにご確認ください。</p>
        <div v-if="applicantsCount.total != 0">
        <template v-if="applicantsCount.total === 1">
          1名表示 / 1名
        </template>
        <template v-else>
          {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 / 全体{{ applicantsCount.total }}名
        </template>
      </div>
    </div>
    <div class="one-left d-xl-flex" style="margin-bottom: 20px;justify-content: space-between;">
      <!-- <div class="d-flex align-items-center"> -->
        <div class="ml-3 d-flex align-items-center">
          <input
            type="checkbox"
            v-model="isCheckAll"
            @click="checkAll()"
            style="width: 18px; height: 18px;"
            
          />
          <div class="ml-4">
            <b-dropdown
              id="bulkActionDropdown"
              text="▼ 一括操作"
              class="bulk-operation-btn"
              variant="secondary"
              size="sm"
            >
              <b-dropdown-item @click="excludeFromReviewList">
                対象から除外
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="one-right" style="margin-left: 60px;">
          <ul class="nostyle ul-button d-flex justify-content-center">
            <li>
              <div
                class="favorite-wrapper favorite-border"
                @click="toggleFavoriteApplicants"
              >
                <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import mutations from '@/config/mutations';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'PendingReviewSearchBar',
  components: {
    Favorite,
  },
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      title: '',
      isDefault: 'no',
      // jobseekerIds: [],
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
    };
  },
  computed: {
    ...mapState({
      applicantsCount: ({ applicant }) => applicant.applicantsCount,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      sortBy: ({ applicant }) => applicant.sortBy,
      searchParams: ({ applicant }) => applicant.searchParams,
      currentUser: ({ user }) => user.currentUser,
      reviewLists: ({ user }) => user.reviewLists,
      checkAllState: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
    }),
    ...mapGetters({
      applicantCounts: 'getApplicantCounts',
    }),
    isCheckAll: {
      get() {
        return this.checkAllState; // Get value from Vuex state
      },
      set(value) {
        this.setCheckAll(value); // Trigger mutation when value changes
      },
    },
    isDepartmentAccount() {
      return !(this.currentUser && this.currentUser.isCreateReviewUser);
    },
    assignedReviewListId() {
      // Get the review list ID that the current user is assigned to
      if (!this.reviewLists || !this.currentUser) return null;
      
      const assignedList = this.reviewLists.find(list => 
        list.client_users && 
        list.client_users.some(clientUser => clientUser._id === this.currentUser.id)
      );
      
      return assignedList ? assignedList._id : null;
    },
    isNoSearch() {
      return Object.keys(this.searchParams).length === 0 && this.sortBy === '';
    },
    titleState() {
      return this.title.length > 2;
    },
  },
  methods: {
    ...mapMutations([mutations.applicant.TOGGLE_FAVORITES, 'setCheckAll', 'mutateApplicantsAfterMultipleStatus', 'setReloadApplicants', 'setJobseekerIds']),
    ...mapActions(['loadReviewLists']),
    toggleFavoriteApplicants() {
      console.log('toggling favorites')
      this[mutations.applicant.TOGGLE_FAVORITES](!this.favoritesOnly);
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.jobseekerIds = [];
      if (this.isCheckAll) {
        // Emit event to parent to get all applicant IDs
        this.$emit('checkAll', this.isCheckAll);
      }
    },
    async excludeFromReviewList() {
        this.errors = [];
        if (this.jobseekerIds.length == 0) {
        return;
        } else {
        // this.loading = true;
        ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST_MULTIPLE, {
            jobseekerIDs: this.jobseekerIds,
            status: '未確認',
            isNewPanel: true,
        })
            .then(({ data }) => {
            this.mutateApplicantsAfterMultipleStatus(data.data);
            this.setCheckAll(false);
            this.setReloadApplicants(true);
            })
            .catch((error) => console.log(error))
            .then(() => {
            // this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
            });
        }
    },
  },
  mounted() {
    // Load review lists to get the assigned review list ID
    this.loadReviewLists();
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },
  },
};
</script>

<style scoped> 

::v-deep .dropdown .btn-secondary {
    background-color: #fff !important;
    color: #3c3c3c !important;
    height: 37px !important;
    width: 200px !important;
    height: 50px !important;
    border-radius: 30px;
    font-size: 16px;
    font-weight: bold;
}

.btn-clear {
  background-color: #f0f5f7;
  border-color: #f0f5f7;
  color: #89969f !important;
}

.bulk-operation-btn .btn.dropdown-toggle {
    font-size: 16px;
    font-weight: bold;
}

.btn-clear:hover,
.btn-clear:focus {
  background-color: #dae0e2 !important;
  border-color: #dae0e2 !important;
}

.one-right .btn-heart:hover i {
  color: #aba2a2;
}

/* Bulk operations styling */
.bulk-operations-section {
  padding: 15px 20px;
  /* background-color: #f8f9fa; */
  border-radius: 6px;
  /* border: 1px solid #e9ecef; */
}

.bulk-operation-btn {

  font-size: 16px;
  font-weight: bold;
  border-radius: 30px
}

</style>
  